import { queryAll, query, fromId } from '../utils/utils.js';

export class UtilityLinkBlock {
    root = query('body');

    constructor() {

        queryAll('.utility-links .utility-link').forEach((link) => {
            const button = link.querySelector('.bhs-link-button');
            if (button) {
                link.addEventListener('click', (e) => {
                    button.click();
                });
                link.addEventListener('mouseover', (e) => {
                    button.classList.add('hover');
                });
                link.addEventListener('mouseout', (e) => {
                    button.classList.remove('hover');
                });
            }
        });

    }

}
